var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$_noItemsAsHtml)?_c('div',{staticClass:"vlNoItems",domProps:{"innerHTML":_vm._s(_vm.$_noItemsFound)}}):_c('div',[_c('component',_vm._b({},'component',_vm.$_noItemsAttributes,false))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }